import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  END_SESSION,
  GET_ACTIVE_SESSIONS,
  GET_HISTORICAL_SESSIONS
} from 'actions/sessions/constants';
import {
  endSessionSuccess,
  endSessionError,
  getActiveSessions,
  getActiveSessionsSuccess,
  getActiveSessionsError,
  getHistoricalSessionsSuccess,
  getHistoricalSessionsError
} from 'actions/sessions';

import normaliseError from 'utils/normaliseError';

import {
  fetchSessions,
  submitEndSession
} from '../../services/api/sessionsApi';

/* Active sessions */
export function* getActiveSessionsSaga({ projectId }) {
  try {
    const response = yield call(fetchSessions, { projectId });
    yield put(getActiveSessionsSuccess(projectId, response.data.data));
  } catch (error) {
    const transformedError = normaliseError(error);
    yield put(getActiveSessionsError(projectId, transformedError));
  }
}

export function* getActiveSessionsWatcher() {
  yield takeLatest(GET_ACTIVE_SESSIONS, getActiveSessionsSaga);
}

/* Historical sessions */
export function* getHistoricalSessionsSaga({ projectId, page = 1 }) {
  try {
    const result = yield call(fetchSessions, {
      projectId,
      historical: true,
      page
    });
    const { data, pagination } = result.data;
    yield put(getHistoricalSessionsSuccess(projectId, data, pagination));
  } catch (error) {
    const transformedError = normaliseError(error);
    yield put(getHistoricalSessionsError(projectId, transformedError));
  }
}

export function* getHistoricalSessionsWatcher() {
  yield takeLatest(GET_HISTORICAL_SESSIONS, getHistoricalSessionsSaga);
}

export function* endSessionSaga({ projectId, streamingSessionId }) {
  try {
    yield call(submitEndSession, streamingSessionId);
    yield put(endSessionSuccess(projectId, streamingSessionId));
    yield put(getActiveSessions(projectId));
  } catch (error) {
    const transformedError = normaliseError(error);
    yield put(endSessionError(projectId, streamingSessionId, transformedError));
  }
}

export function* endSessionWatcher() {
  yield takeEvery(END_SESSION, endSessionSaga);
}

export default function* rootSaga() {
  yield all([
    call(endSessionWatcher),
    call(getActiveSessionsWatcher),
    call(getHistoricalSessionsWatcher)
  ]);
}
